/**
 * 视频译配模块路由配置
 */
import type { RouteRecordRaw } from 'vue-router'
import { Permission } from '@/utils/permission'
import { 
  Upload as VideoUpload,
  SubtitleEditorWrapper,
  TranslationReview,
  Results as VideoResults
} from '@/modules/video/views'

const videoRoutes: RouteRecordRaw[] = [
  {
    path: 'video',
    name: 'Video',
    meta: {
      titleKey: 'menu.video',
      title: '视频译配',
      requiresAuth: true,
      // 与 DB permission_code 一致
      permissions: [
        Permission.VIDEO_UPLOAD,
        Permission.VIDEO_SUBTITLE,
        Permission.VIDEO_TRANSLATE,
        Permission.VIDEO_ASSIGN
      ],
      icon: 'VideoCameraOutlined'
    },
    children: [
      {
        path: 'upload',
        name: 'VideoUpload',
        component: VideoUpload,
        meta: {
          titleKey: 'menu.videoUpload',
          title: '视频上传',
          requiresAuth: true,
          permissions: [Permission.VIDEO_UPLOAD],
          breadcrumb: true
        }
      },
      {
        path: 'subtitle-edit/:id',
        name: 'SubtitleEdit',
        component: SubtitleEditorWrapper,
        meta: {
          title: '字幕编辑',
          requiresAuth: true,
          permissions: [Permission.VIDEO_SUBTITLE],
          breadcrumb: true,
          hidden: true
        }
      },
      {
        path: 'subtitle-editor/:id',
        name: 'SubtitleEditor',
        component: SubtitleEditorWrapper,
        meta: {
          title: '字幕编辑器',
          requiresAuth: true,
          permissions: [Permission.VIDEO_SUBTITLE],
          breadcrumb: true,
          hidden: true
        }
      },
      {
        path: 'translation-review/:id',
        name: 'TranslationReview',
        component: TranslationReview,
        meta: {
          title: '翻译校验',
          requiresAuth: true,
          permissions: [Permission.VIDEO_TRANSLATE, Permission.TASK_EDIT],
          breadcrumb: true,
          hidden: true
        }
      },
      {
        path: 'results/:id',
        name: 'VideoResults',
        component: VideoResults,
        meta: {
          title: '视频翻译结果',
          requiresAuth: true,
          permissions: [Permission.VIDEO_TRANSLATE],
          breadcrumb: true,
          hidden: true
        }
      }
    ]
  }
]

export default videoRoutes

